import * as types from '../types';
import update from 'immutability-helper';
import moment from 'moment'
import {
    VIEW_MODE,
    EDIT_MODE,
} from '@Utils/constants';


const initialTitle = 'Interviews';

export const initialDetailForm = {
    companyID: 0,
    UserID: 0,
    applicantID: 0,
    applicantName: '',
    applicantEmail: '',
    interviewer: 0,
    interviewerEmail: '',
    positionApplied: 0,
    applicantStatus: 0,
    interviewSchedule: moment().format('MM/DD/YYYY HH:mm'),
    interviewMode: 0,
    addressOrLink: '',
    remarks: '',
    positionLevel: 0,
    positionAccepted: 0,
    recommendedSalary: 0.0,
    interviewResult: 0,
    auditTrail: [],
}

const defaultState = {
    title: 'Interviews',
    mode: VIEW_MODE,
    loading: true,
    hasLoadedData: false,
    isEditable: false,
    detailForm: { ...initialDetailForm },
    alert: {
        show: false,
        title: 'Update success',
        content: 'Successfuly updated record.',
        confirmLabel: 'Ok',
        goBackToListFlag: false,
        onHide: () => { },
    },
};

export default function detailReducer(state = defaultState, action) {
    switch (action.type) {
        case types.UPD_AMOUNT:
        case types.CHG_DETAIL_DATA:
            return update(state, {
                detailForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.UPD_DETAIL_TITLE:
            return update(state, {
                title: { $set: action.payload }
            });
        case types.UPD_DETAIL_MODE:
            return update(state, {
                mode: { $set: action.payload }
            });
        case types.HAS_DETAIL_LOADED:
            return update(state, {
                hasLoadedData: { $set: action.payload }
            });
        case types.SET_DETAIL_DATA:
            let data = action.payload;

            let initialMode = action.mode === 'view' ? VIEW_MODE : EDIT_MODE;
            let editable = initialMode === EDIT_MODE ? true : false;
            return update(state, {
                title: { $set: initialTitle },
                mode: { $set: initialMode },
                isEditable: { $set: editable },
                detailForm: { $set: data },
                alert: { $set: defaultState.alert }
            });
        case types.RESET_DETAIL_DATA:
            return update(state, {
                detailForm: {
                    interviewSchedule: { $set: moment().format('MM/DD/YYYY HH:mm') },
                    remarks: { $set: '' },
                    recommendedSalary: { $set: 0 },
                    interviewMode: { $set: 0 },
                    addressOrLink: { $set: '' },
                    interviewResult: { $set: '' },
                }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.HIDE_DETAIL_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            });
        case types.SET_DETAIL_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.SET_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: { $set: action.payload }
            });
        case types.HIDE_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: false }
                }
            });
        case types.SHOW_DETAIL_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: true }
                }
            });
        default:
            return state;
    }
}
